import { queryType } from '@blade-sxp/search-center/interfaces/enum';
export const remove = (arr, val) => {
    const index = arr.indexOf(val);
    if (index > -1) {
        arr.splice(index, 1);
    }
    return arr;
};
export const distinct = (arr, key) => {
    for (let i = 0; i < arr.length; i++) {
        for (let j = i + 1; j < arr.length; j++) {
            if (arr[i][key] === arr[j][key]) {
                arr.splice(j, 1);
                j = j - 1;
            }
        }
    }
    return arr;
};
export const deepClone = (val) => {
    const _obj = JSON.stringify(val);
    const objClone = JSON.parse(_obj);
    return objClone;
};
export const parameterType = (featureList, defaultType, vehicle, attributeFiltering) => {
    let feature = {
        attributeMaps: undefined,
        featureType: '',
        featureValue: '',
        imageUrl: '',
        version: null,
    };
    const copyfeatureList = deepClone(featureList);
    if (defaultType === queryType.AUTOMOBILE) {
        // 查询车牌
        feature = copyfeatureList.find((item) => item.featureType === queryType.AUTOMOBILE);
        console.log('feature1', feature);
        if (feature['attributeMaps']?.st_plate_nos)
            delete feature['attributeMaps'].st_plate_nos;
        if (JSON.stringify(attributeFiltering) === '{}')
            feature['attributeMaps'] = {};
        for (const key in feature) {
            if (key === 'attributeMaps' && vehicle) {
                feature[key].st_plate_nos = [vehicle.trim()];
            }
        }
    }
    else {
        const type = defaultType;
        if (defaultType === queryType.FACE_BODY)
            defaultType = queryType.FACE;
        if (defaultType === queryType.BODY_FACE)
            defaultType = queryType.PEDESTRIAN;
        feature = copyfeatureList.find((item) => item.featureType === defaultType);
        console.log('feature2', feature, defaultType);
        if (type === queryType.FACE_BODY || type === queryType.BODY_FACE) {
            feature.featureType = type;
        }
        if (JSON.stringify(attributeFiltering) === '{}' && feature)
            feature['attributeMaps'] = {};
    }
    return feature;
};
